<div class="advEditView">
  <ng-container *ngIf="services.advService.bannersEnabled">
    <div class="adsContainer" *ngIf="!isPremium || !services.enableSubscription">
      <app-banner-zone-map [zoneType]="['Mobile-Ads', 'Mobile-Ads-2']" [isMobile]="true" ></app-banner-zone-map>
    </div>
  </ng-container>

    <form class="formFields advEditView__formFields" novalidate 
     [formGroup]="advForm"
     (ngSubmit)="onSubmit()"
     #form
     [uploadInputFor]="This">
      <div class="advEditView__premiumView" *ngIf="AdView == 1 && !Expired">
        <premium-ad-token-payment #adTokenPaymentForm [payButtonText]="'Pay $1.99 for Premium Ad Now'" (onTokenAdded)="onTokenAdded($event)"  *ngIf="!isThirdPartyAd"></premium-ad-token-payment>
        <premium-ad-token-payment #adTokenPaymentForm [payButtonText]="'Pay $99 for Third Party Ad Now'" (onTokenAdded)="onTokenAdded($event, true)" [paymentFormType]="2" *ngIf="isThirdPartyAd"></premium-ad-token-payment>
      </div>
      <div class="advEditView__formFields" *ngIf="AdView == 0 || Expired">
          <mat-card class="advEditView__matCard">
            <mat-card-content>
       
              <mat-radio-group class="formFields__radioGroup" color="primary" (change)="changeAdType($event)" *ngIf="!SpecialUser || isThirdPartyAd" >
                <mat-radio-button class="" [disabled]="(!isNew() && adv != null && adv.isPremium)" [checked]="AdType == 0" [value]="0" *ngIf="!isThirdPartyAd">Free</mat-radio-button>
                <mat-radio-button class="" [checked]="AdType == 1" [value]="1"  *ngIf="!isThirdPartyAd">Premium Verified Ad <span *ngIf="UserPremiumAdToken > 0">
                  ({{UserPremiumAdToken }} Credit Left)</span>
                </mat-radio-button>
                <mat-radio-button class="inline-radio" [checked]="isThirdPartyAd" [value]="2" *ngIf="isThirdPartyAd && HasUserThirdPartyAdToken">
                  Third party Ad - <span style="color: #ff4081">({{UserThirdPartyAdToken }} Credit Left)</span>
                </mat-radio-button>
              </mat-radio-group>
         
              <mat-radio-group class="formFields__radioGroup formFields__radioGroup--dating" color="primary"  aria-label="Select an option" formControlName="casualDating">
                <mat-radio-button class="" value="true">Casual Dating</mat-radio-button>
                <mat-radio-button class="" value="false">Long Term Relationships</mat-radio-button>
              </mat-radio-group>
        
              <mat-form-field class="formFields__prersonType" *ngIf="!isThirdPartyAd">
                <mat-select placeholder="Who you are" [(value)]="selectedPersonType" formControlName="selectedPersonType" required="true">
                  <mat-option *ngFor="let personType of personTypes" [value]="personType.value">{{ personType.text }}</mat-option>
                </mat-select>
              </mat-form-field>
          
              <mat-form-field class="formFields__relationship" [hidden]="!advForm.controls.selectedPersonType.value" *ngIf="!isThirdPartyAd">
                <mat-select placeholder="Relationship"
                            formControlName="relationShips"
                            required="true">
                  <mat-option (click)="advForm.controls.relationShips.reset()"></mat-option>
                  <mat-option *ngFor="let sg of filteredCategories"
                              [value]="sg.advertisementCategoryId">
                    {{ categoryDisplayName(sg.advertisementCategoryId)}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <div class="formFields__address" *ngIf="!IsDemoAd && !isThirdPartyAd">
                <mat-form-field class="formFields__state">
                  <mat-select required placeholder="State"
                              formControlName="region"
                              (selectionChange)="setSelectedRegion($event.value)">
                    <mat-option>
                      <ngx-mat-select-search [placeholderLabel]="'ex. Washington'"
                                              [noEntriesFoundLabel]="'No matching found'"
                                              [formControl]="regionFilter"></ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let r of filteredRegions"
                                [value]="r.regionId">
                      {{ r.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="advForm.controls['region'].hasError('region')">
                    State is required
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="formFields__zip">
                  <input matInput
                          type="text"
                          placeholder="Zip code"
                          formControlName="postalCode"
                          required />
                  <mat-error *ngIf="
                      advForm.controls['postalCode'].hasError('postalCode')
                    ">
                    Zip code is required
                  </mat-error>
                </mat-form-field>
      
                <mat-form-field class="formFields__city" [hidden]="!advForm.controls.region.value">
                  <mat-select required placeholder="City"
                              (selectionChange)="onChangesSelect($event)"
                              formControlName="subregion">
                    <mat-option>
                      <ngx-mat-select-search [placeholderLabel]="'ex. Newport'"
                                              [noEntriesFoundLabel]="'No matching found'"
                                              [formControl]="subregionFilter"></ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let r of filteredSubregion"
                                [value]="r.subRegionId">
                      {{ r.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="
                      advForm.controls['subregion'].hasError('subregion')
                    ">
                    City is required
                  </mat-error>
                </mat-form-field>
              </div>
          
              <mat-form-field class="formFields__nick">
                <input matInput
                        type="text"
                        placeholder="Your Nick"
                        formControlName="nick"
                        required />
                <mat-error *ngIf="advForm.controls['nick'].hasError('nick')">
                  Nick is required
                </mat-error>
              </mat-form-field>
        
              <mat-form-field class="formFields__age" *ngIf="!isThirdPartyAd">
                <input matInput
                        type="number"
                        placeholder="Age"
                        formControlName="age" />
              </mat-form-field>

              <mat-form-field class="formFields__title">
                <input #titleInput
                        matInput
                        (blur)="titleBlur($event)"
                        maxlength="255"
                        type="text"
                        placeholder="Ad Title"
                        formControlName="title"
                        required
                        (click)="titleClick($event)" />
                <mat-error *ngIf="advForm.controls['title'].hasError('title')">
                  Ad Title is required
                </mat-error>
                <div class="advEditView__emojiContainer">
                  <emoji-picker class="emojiPicker"
                                (click)="scrollView($event)"
                                (change)="updateTitle($event)"
                                [text]="advForm.controls['title'].value"
                                [element]="titleInput"
                                *ngIf="isPremiumFunctionality || isThirdPartyAd">
                  </emoji-picker>
                </div>
              </mat-form-field>

              <div class="formFields__description">
                <mat-form-field class="without-pb-field">
                  <textarea #descriptionInput
                            maxlength="8192"
                            (blur)="descriptionBlur($event)"
                            cdkTextareaAutosize
                            cdkAutosizeMinRows="2"
                            cdkAutosizeMaxRows="10"
                            matInput
                            placeholder="Description"
                            formControlName="content"
                            required>
                  </textarea>
                  <mat-error *ngIf="advForm.controls['content'].hasError('required')">
                    Content is required
                  </mat-error>
                  <div class="advEditView__emojiContainer">
                    <emoji-picker class="emojiPicker"
                                  (change)="updateContent($event)"
                                  [text]="advForm.controls['content'].value"
                                  [element]="descriptionInput"
                                  *ngIf="isPremiumFunctionality || isThirdPartyAd">
                    </emoji-picker>
                  </div>
                </mat-form-field>
              </div>
              <div class="" *ngIf="Expired && AdType==1 && !SpecialUser && !HasUserPremiumAdToken && !isThirdPartyAd">
                <premium-ad-token-payment></premium-ad-token-payment>
              </div>
              <div class="" *ngIf="Expired && isThirdPartyAd && !HasUserThirdPartyAdToken">
                <premium-ad-token-payment [payButtonText]="'Pay $99 for Third Party Ad Now'" [paymentFormType]="2"></premium-ad-token-payment>
              </div>
              
              <div class="formFields__chooseFile choose-file" *ngIf="!isMaxImagesExeeded()">
                <button class="button" type="button" mat-icon-button  (click)="fileInput.click()">
                  <mat-icon aria-hidden="false" aria-label="add photo button">add_a_photo</mat-icon>
                </button>
                <input id="singleFile"
                      type="file"
                      accept="image/x-png,image/gif,image/jpeg"
                      hidden
                      [uploadInputFor]="This" #fileInput/>
              </div>

              <div class="formFields__imageInfo">
                <b>Nude or explicit photos will be removed </b>
                <a href="/b/terms-of-use/" target="_blank">Terms and Conditions</a>
              </div>

              <div 
               class="formFields__imageHolder w-45 mr-1 mb-1"
               _cdkDrag
               (mouseover)="overAction(i)"
               (cdkDragStarted)="cdkDragStarted($event, childItem, i)"
               (cdkDragReleased)="cdkDragReleased($event, i)"
               *ngFor="let img of images; let i = index"
               (click)="selectedImage = img">
                <button class="image-delete" mat-icon-button (click)="deleteImage(img)">
                  <mat-icon>delete_outline</mat-icon>
                </button>

                <div imageLoader class="image" backgroundSrc="{{img.imageUrl + '/350x200'}}"></div>
              </div>
            </mat-card-content>

            <mat-card-actions class="">
              <div class="formFields__checkbox">
                  <mat-checkbox formControlName="termAccepted" (change)="termsAcceptAction($event)"></mat-checkbox>

                  <mat-card-subtitle>
                    * Your ad will expire after 2 weeks. By posting an ad
                    on WickedList.com you agree to be bound by our
                    <a href="https://wickedlist.com/b/terms-of-use/" target="_blank">Terms And Conditions</a> and our
                    <a href="https://wickedlist.com/b/privacy-policy/" target="_blank">Privacy Policy</a>
                  </mat-card-subtitle>
              </div>

              <div class="formFields__captcha">
                <re-captcha (resolved)="captchaResolved($event)"
                            *ngIf="this.captchaAvailable()"
                            size="200px"
                            [siteKey]="this.captchaService.getCurrentCaptchaKey()">
                </re-captcha>
                <span *ngIf="!this.captchaAvailable()">
                  For use captcha, you should configure captcha site key
                  properly
                </span>
              </div>

              <div class="formFields__actions">
                <button *ngIf="!Expired"
                        class="formFields__btSubmit"
                        mat-raised-button 
                        color="primary"
                        [disabled]="submitInProgress || termsNotAccepted"
                        type="submit">
                  <span>{{this.submitInProgress ? "Submitting" : "Submit"}}</span>
                </button>

                <button *ngIf="Expired"
                        class="advEditView__btSubmit"
                        mat-raised-button 
                        color="primary"
                        [disabled]="submitInProgress || termsNotAccepted"
                        type="submit">
                  <span *ngIf="Expired && AdType==1 && !SpecialUser"><span *ngIf="!HasUserPremiumAdToken">Pay 1.99$ & </span>Re-List</span>
                  <span *ngIf="Expired && ((AdType==0 && !SpecialUser) || SpecialUser)">Re-List</span>
                </button>

                <button class="formFields__deleteAd" *ngIf="!isNew()"
                  type="button"
                  mat-raised-button 
                  color="primary"
                  (click)="tryDeleteAd()">
                    <span>Delete Ad</span>
                    <mat-icon class="posicon">delete</mat-icon>
                </button>
               
              </div>
            </mat-card-actions>
          </mat-card>
      </div>
    </form>
</div>
